import * as React from 'react';
import { SVGProps } from 'react';

const IconGradientsSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 0H4v5H3v5h1v2h1V9H4V6h1V0ZM7 12h1V7h1V2H8V0H7v3h1v3H7v6Z" />
  </svg>
);
export default IconGradientsSizeXs;
